import { render, staticRenderFns } from "./TotalTransactionDataPannel.vue?vue&type=template&id=061edb32&scoped=true"
import script from "./TotalTransactionDataPannel.vue?vue&type=script&lang=js"
export * from "./TotalTransactionDataPannel.vue?vue&type=script&lang=js"
import style0 from "./TotalTransactionDataPannel.vue?vue&type=style&index=0&id=061edb32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061edb32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061edb32')) {
      api.createRecord('061edb32', component.options)
    } else {
      api.reload('061edb32', component.options)
    }
    module.hot.accept("./TotalTransactionDataPannel.vue?vue&type=template&id=061edb32&scoped=true", function () {
      api.rerender('061edb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/dashboard/components/TotalTransactionDataPannel.vue"
export default component.exports